<div class="wrapper-lg">
    <app-breadcrumbs [items]="[{ url: '/plan-summary', text: 'planSummary_title' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'planSummary_title' | translate}}</h1>
        <aside *ngIf="canPickStudent && !studentPickerOpened">
            <button type="button" class="btn btn-outline" (click)="toggleStudentPicker()">
                <i class="fi fi-rs-user"></i>
                {{'planSummary_btnPickStudent' | translate}}
            </button>
        </aside>
    </header>

    <app-person-picker *ngIf="studentPickerOpened" (pick)="pickStudent($event)"></app-person-picker>

    <ng-container *ngIf="!studentPickerOpened">
        <app-alert level="warning" *ngIf="notAvailable">{{'eServicesNotAvailable' | translate}}</app-alert>

        <div class="row" *ngIf="residentInfo.length > 1">
            <div class="col-sm-6 form-field">
                <label class="form-label">{{'planSummary_lblChangeSpeciality' | translate}}</label>
                <app-select [(ngModel)]="specialityId"
                            [options]="residentInfo"
                            [valueProperty]="'SpecialityId'"
                            [displayFn]="specialityDisplayFn"
                            [required]="true"
                            (selectionChange)="onSpecialityChange()"
                            name="specialityId">
                </app-select>
            </div>
        </div>

        <ng-container *ngIf="resident">
            <ng-container *ngFor="let n of alerts">
                <app-alert [level]="n.level">
                    <ng-container *ngFor="let a of n.items; let i = index">
                        <div *ngIf="i < 2 || n.expanded" [class.mt-1]="i > 0">{{a.Text}}</div>
                    </ng-container>
                    <div class="mt-1" *ngIf="n.items.length > 2">
                        <a href="#" (click)="$event.preventDefault(); n.expanded = !n.expanded">
                            {{(n.expanded ? 'planSummary_btnShowLess' : 'planSummary_btnShowMore') | translate}}
                        </a>
                    </div>
                </app-alert>
            </ng-container>

            <div class="data-value" *ngIf="overallProgress">
                <label>{{'planSummary_lblOverallProgress' | translate}}</label>
                <div>
                    <span class="total-circle bg-danger"></span>
                    {{getProgressDetailsString(overallProgress)}}
                </div>
            </div>

            <nav class="nav-horizontal">
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn btn-outline" ngbDropdownToggle>
                        {{currentTab?.title | translate}}
                    </button>
                    <div ngbDropdownMenu>
                        <button ngbDropdownItem *ngFor="let tab of tabs; let i = index" (click)="activeTabId = i">
                            {{tab.title | translate}}
                        </button>
                    </div>
                </div>
            </nav>

            <div class="main">
                <nav class="nav-vertical hidden-sm-down">
                    <ul>
                        <li *ngFor="let tab of tabs; let i = index"
                            (click)="activeTabId = i"
                            [class.active]="i == activeTabId">
                            <i class="fi fi-rs-{{tab.icon}}" *ngIf="tab.icon"></i>
                            {{tab.title | translate}}
                        </li>
                    </ul>
                </nav>

                <div class="content">
                    <ng-container [ngSwitch]="currentTab.id">
                        <app-plan-summary-base-info *ngSwitchCase="'base'"
                                                    [resident]="resident"
                                                    [supervisor]="supervisor"></app-plan-summary-base-info>

                        <app-plan-summary-courses *ngSwitchCase="'courses'"
                                                  [studyYear]="resident.StudyYear"></app-plan-summary-courses>

                        <app-plan-summary-upcoming-courses *ngSwitchCase="'plan'"></app-plan-summary-upcoming-courses>

                        <app-plan-summary-manipulations *ngSwitchCase="'manipulations'"
                                                        [residentEmail]="resident.Email"></app-plan-summary-manipulations>

                        <app-plan-summary-shifts *ngSwitchCase="'shifts'"
                                                 [residentEmail]="resident.Email"
                                                 [studyYear]="resident.StudyYear"
                                                 [getFileUrlFn]="getFileUrlFn"></app-plan-summary-shifts>

                        <app-plan-summary-seminars *ngSwitchCase="'seminars'"
                                                   [studyYear]="resident.StudyYear"></app-plan-summary-seminars>

                        <app-plan-summary-documents *ngSwitchCase="'documents'"
                                                    [studentEmail]="resident.Email"></app-plan-summary-documents>

                        <app-plan-summary-quality-evaluation *ngSwitchCase="'evaluation'"
                                                             [resident]="resident"
                                                             [supervisor]="supervisor"></app-plan-summary-quality-evaluation>

                        <app-plan-summary-events *ngSwitchCase="'events'"
                                                 [resident]="resident"></app-plan-summary-events>

                        <app-plan-summary-totals *ngSwitchCase="'totals'"></app-plan-summary-totals>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>
